export interface ISectionResult {
  key: string;
  label: string;
  startIdx: number;
  count: number;
}

export const getSections = (totalQuestions: number): ISectionResult[] => {
  const goalsCount = 15;
  const contactCount = 2;
  const medicalCount = Math.max(totalQuestions - goalsCount - contactCount, 0);

  return [
    {
      key: "goals",
      label: "GOALS",
      startIdx: 0,
      count: goalsCount,
    },
    {
      key: "medical",
      label: "MEDICAL HISTORY",
      startIdx: goalsCount,
      count: medicalCount,
    },
    {
      key: "contact",
      label: "CONTACT",
      startIdx: goalsCount + medicalCount,
      count: contactCount,
    },
  ];
};
